import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import { Chip, Stack } from '@mui/material';
import type { CheckedSkill } from '@/packages/skill-management/context/types';

const MINIMUM_TOTAL_SKILLS = 12;
const MINIMUM_UNCHECKED_SKILLS = 3;

type SkillsListProps = {
  checkedSkills: CheckedSkill[];
  uncheckedSkills: CheckedSkill[];
  onClick: () => void;
};

export const SkillsList = ({
  checkedSkills,
  uncheckedSkills,
  onClick,
}: SkillsListProps) => {
  const uncheckedSkillsCount = Math.max(
    MINIMUM_TOTAL_SKILLS - checkedSkills.length,
    MINIMUM_UNCHECKED_SKILLS
  );
  const uncheckedToShow = uncheckedSkills.slice(0, uncheckedSkillsCount);
  const remainingUnchecked = uncheckedSkills.length - uncheckedToShow.length;

  const chipMaxWidth = { xs: '200px', sm: '250px', md: '400px' };

  return (
    <Stack direction="row" flexWrap="wrap" flex={1} gap={1}>
      {checkedSkills.map((skill) => (
        <Chip
          key={skill.id}
          label={skill.skill.name_pt}
          icon={<CheckIcon fontSize="small" />}
          sx={{ maxWidth: chipMaxWidth }}
          onClick={onClick}
        />
      ))}
      {uncheckedToShow.map((skill) => (
        <Chip
          key={skill.id}
          label={skill.skill.name_pt}
          variant="outlined"
          icon={<AddIcon fontSize="small" />}
          sx={{ maxWidth: chipMaxWidth }}
          onClick={onClick}
        />
      ))}
      {remainingUnchecked > 0 && (
        <Chip
          label={`+${remainingUnchecked} habilidades`}
          variant="outlined"
          onClick={onClick}
        />
      )}
    </Stack>
  );
};
